import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DTFHomepageService } from '../dtfhomepage/dtfhomepage.service';
import { AuthorizationService } from '../authorization/authorization.service';
import { WindowRef } from '../../utils/window';

import { TranslateService } from '@ngx-translate/core';
import { Banner } from '../../shared/models/banner';
import { TranslateUtil } from '../../utils/translate-util';
import { APP_CONSTANTS } from '../../utils/app-constants';
import { SharedTranslateModule } from '../../utils/sharedTranslateModule';
import { VideoComponent } from '../video/video.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatPaginator } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSort } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { SessionTimeoutComponent } from '../sessionTimeout/sessionTimeout.component';

interface Requests {
  value: string;
  viewValue: string;
}

@Component({
    selector: 'div.dashboardpage',
    imports: [SharedTranslateModule, MatTableModule, MatInputModule, MatCheckboxModule, MatFormFieldModule, SessionTimeoutComponent,
        MatInputModule, FormsModule, MatSelectModule, ReactiveFormsModule, MatButtonToggleModule, MatDatepickerModule],
    templateUrl: './dashboard.component.html',
    providers: []
})
export class DTFDashboardComponent implements OnInit {
  title = 'Content Section of the Page';
  router: Router;
  path = '';
  loginRedirect = '';
  accountRedirect = '';
  token: string;
  brandId: string;
  loginAttempt = false;
  isLoginattempt = '';
  newAccount = false;
  countryFlag: string;
  langFlag: string;
  currentCountry: string;
  isCanadaPortal = false;
  usUrl: string;
  caUrl: string;
  azURL: string;
  agentview: string;
  agentId: string;
  bodyLoaded = false;
  dbData: any;
  public alerts: Banner;
  toggleOpen: any;
  recAccCount ='';
  totalDue ='';
  language = '';
  videoredirect = '';
  ciamId = sessionStorage.getItem('loginID');
  showVideo = false;
  trans_history = false;
  lessAccounts = true;
  liveAccFlag: boolean;
  thirdParty: string;
  thirdPartyObject: string;
  selectedRequests: Requests[] = [
    {value: 'onlinepayment', viewValue: 'Make a Payment'},
    {value: 'principalpayment', viewValue: 'Principal Payment'},
    {value: 'recurringpayment', viewValue: 'Recurring Payment'},
    {value: 'statementpayment', viewValue: 'Statement Payment'},
    {value: 'paymenthistory', viewValue: 'Payment History'},
    {value: 'bankprofile', viewValue: 'Manage Bank Profile'},
    {value: 'help', viewValue: 'Help'},  
  ];
  isTerminatedAccounts = false;

  DTPAY =  true;

  constructor(router: Router,private dtfhomepageService: DTFHomepageService, public auth: AuthorizationService,
              private _window: WindowRef, public translate: TranslateService, public translateUtil: TranslateUtil){
    this.router = router;
    this.usUrl = (this._window.nativeWindow as any).mbfs.usUrl;
    this.caUrl = (this._window.nativeWindow as any).mbfs.caUrl;
  }

  ngOnInit() {
    this.DtpayToggle();
    this.getAccountSummary();
    this.thirdParty = sessionStorage.getItem('thirdPartyNumber');
    this.agentview = sessionStorage.getItem('agentview');
    this.agentId = sessionStorage.getItem('agentID');
    const language = (window as any).mbfs.language;
    const country = (window as any).mbfs.country;
    this.countryFlag = country;
    this.langFlag = language;
    this.brandId = sessionStorage.getItem('brandId');
    this.token = sessionStorage.getItem('ciamToken');

    this.translateUtil.setCountryAndLangFromUIProp();
    this.translateUtil.getCurrentCountry().subscribe(val => {
        this.isCanadaPortal = (val === APP_CONSTANTS.COUNTRY_CA) ? true : false;
        this.currentCountry = val;
    });

    const dashBoardRequest = {
      ciamId : this.ciamId ,
      ciamAZCode :this.token
    };
    this.getDashBoardDetails(dashBoardRequest);
  }

  clickvideo(redirect: string){
    sessionStorage.removeItem('videoRedirect');
    this.showVideo = false;
    if(redirect === "viewAccounts"){
      this.videoredirect =this.usUrl + "/static/videos/DTFWebsite-ViewAccountsandPayNow7-25-24_1.mp4";
    }
    else if (redirect === "autopay"){
      this.videoredirect =this.usUrl + "/static/videos/DTFWebsite-Autopay&Ebill6-3-24_1.mp4";
    }
    else if (redirect === "amort"){
      this.videoredirect =this.usUrl + "/static/videos/DTFWebsite-AmortizationSchedule6-3-24_1.mp4";
    }
    else if (redirect === "payoff"){
      this.videoredirect =this.usUrl + "/static/videos/DTFWebsite-Payoff&Balance6-3-24_1.mp4";
    }
    else if (redirect === "payment"){
      this.videoredirect =this.usUrl + "/static/videos/DTFWebsite-PaymentHistory6-3-24_1.mp4";
    }
    else if (redirect === "invoice"){
      this.videoredirect =this.usUrl + "/static/videos/DTFWebsite-Invoices&Documents6-3-24_1.mp4";
    }
    else if (redirect === "profile"){
      this.videoredirect =this.usUrl + "/static/videos/DTFWebsite-Profile6-3-24_1.mp4";
    }

    sessionStorage.setItem('videoRedirect', this.videoredirect);

    let azURL =  this.usUrl + '/home/video';

    setTimeout(() => {
      window.open(azURL, '_blank', 'width=1200, height=900');
    }, 500);  //1s
  }


  paymenthistory(){
    this.azURL =  this.usUrl + '/home/paymenthistory';
    setTimeout(() => {
      this._window.nativeWindow.location.href = this.azURL;
      if (sessionStorage.getItem('enableGA') === 'yes' && this.azURL) {
        this.enableGA('true',  'paymenthistory'); 
      }
  }, 1000);
  }

  paymenthistoryCA(){
    if(this.langFlag === 'fr-CA'){
      this.azURL = this.usUrl + '/ca/fr/home/paymenthistory';
      setTimeout(() => {
        this._window.nativeWindow.location.href = this.azURL;
        if (sessionStorage.getItem('enableGA') === 'yes' && this.azURL) {
          this.enableGA('true', 'paymenthistory'); 
        }
      }, 1000);
    }else {
    this.azURL = this.usUrl + '/ca/en/home/paymenthistory';
    setTimeout(() => {
      this._window.nativeWindow.location.href = this.azURL;
      if (sessionStorage.getItem('enableGA') === 'yes' && this.azURL) {
        this.enableGA('true',  'paymenthistory'); 
      }
    }, 1000);
   }
  }

  checkUrlPay(redirect: string) {
    if (redirect === "recurringpayment") {
      this.azURL = this.usUrl + '/home/recurringpayment';
      setTimeout(() => {
        this._window.nativeWindow.location.href = this.azURL;
      }, 1000);
    }
    else if (redirect === "onlinepayment") {
      this.azURL = this.usUrl + '/home/onlinepayment';
      setTimeout(() => {
        this._window.nativeWindow.location.href = this.azURL;
      }, 1000);
    }
    else if (redirect === "principalpayment") {
      this.azURL = this.usUrl + '/home/principalpayment';
      setTimeout(() => {
        this._window.nativeWindow.location.href = this.azURL;
      }, 1000);
    }
    else if (redirect === "bankprofile") {
      this.azURL = this.usUrl + '/home/bankprofile';
      setTimeout(() => {
        this._window.nativeWindow.location.href = this.azURL;
      }, 1000);
    }
    else if (redirect === "paymenthistory") {
      this.trans_history = true;
      this.azURL = this.usUrl + '/home/paymenthistory';
      setTimeout(() => {
        this._window.nativeWindow.location.href = this.azURL;
      }, 1000);
    }
    else if (redirect === "statementpayment") {
      this.trans_history = true;
      this.azURL = this.usUrl + '/home/statementpayment';
      setTimeout(() => {
        this._window.nativeWindow.location.href = this.azURL;
      }, 1000);
    }
    else if (redirect === "help") {
      this.trans_history = true;
      this.azURL = this.usUrl + '/home/help';
      setTimeout(() => {
        this._window.nativeWindow.location.href = this.azURL;
        if (sessionStorage.getItem('enableGA') === 'yes' && this.azURL) {
          this.enableGA('true',  redirect); 
        }
      }, 1000);
    }

    
  }
  

  checkUrl(redirect: string) {
    this.isLoginattempt = sessionStorage.getItem('loginAttempt');
    sessionStorage.setItem('classicredirect', 'yes');
    this.formatAccountURl(redirect);
  }
  anouncementMgsopen(e: any) {
    e.preventDefault();
    if (this.toggleOpen) {
      this.toggleOpen = false;
    } else {
      this.toggleOpen = true;
    }
  }

  DtpayToggle() {
    this.dtfhomepageService.PayToggle().subscribe((res) => {
      for (var i = 0; i < res.length; i++) {
        if (res[i].bannerType === "Pay" && res[i].bannerEnable === "Y" && res[i].bannerExtra === null) {
          this.DTPAY = false;
        }
      }
    });
  }

  formatAccountURl(redirect: string) {
    this.bodyLoaded = true;
    window.scrollTo(0, 0); // used to scroll to top of page
    if (this.countryFlag === 'CA') //CA Logic
    {
      this.azURL =  this.accountRedirect + '?blink=' + redirect;
      if(this.langFlag === 'fr-CA'){
          if (redirect === 'insurance'){
            this.azURL =  this.usUrl + '/ca/fr/home/insurance';
          }
          else if (redirect === 'account'){
            this.azURL =  this.usUrl + '/ca/fr/home/accountdetails';
          }
          else if (redirect === 'payoff'){
            this.azURL =  this.usUrl + '/ca/fr/home/payoff';
          }
          else if (redirect === 'pay'){
            this.azURL =  this.usUrl + '/ca/fr/home/paymentOption';
          }
          else if (redirect ==='amortization'){
            this.azURL =  this.usUrl + '/ca/fr/home/amortization';
          }
          else if (redirect ==='documentcenter'){
            this.azURL =  this.usUrl + '/ca/fr/home/documentcenter';
          }
          else if (redirect ==='invoice'){
            this.azURL =  this.usUrl + '/ca/fr/home/invoice';
          }
          else if (redirect ==='manageYourProfile'){
            this.azURL =  this.usUrl + '/ca/fr/home/manageYourProfile';
          }
          else if (redirect ==='ebill'){
            this.azURL =  this.usUrl + '/ca/fr/home/manageYourProfile?openProfile=ebill';
          }
          
         
      }
      else{
        if (redirect === 'insurance'){
          this.azURL =  this.usUrl + '/ca/en/home/insurance';
        }
        else if (redirect === 'account'){
          this.azURL =  this.usUrl + '/ca/en/home/accountdetails';
        }
        else if (redirect === 'payoff'){
          this.azURL =  this.usUrl + '/ca/en/home/payoff';
        }
        else if (redirect === 'pay'){
          this.azURL =  this.usUrl + '/ca/en/home/paymentOption';
        }
        else if (redirect ==='amortization'){
          this.azURL =  this.usUrl + '/ca/en/home/amortization';
        }
        else if (redirect ==='documentcenter'){
          this.azURL =  this.usUrl + '/ca/en/home/documentcenter';
        }
        else if (redirect ==='invoice'){
          this.azURL =  this.usUrl + '/ca/en/home/invoice';
        }
        else if (redirect ==='manageYourProfile'){
          this.azURL =  this.usUrl + '/ca/en/home/manageYourProfile';
        }
        else if (redirect ==='ebill'){
          this.azURL =  this.usUrl + '/ca/en/home/manageYourProfile?openProfile=ebill';
        }
      }
    }
    else{ //US Logic
      this.azURL =  this.accountRedirect + '?blinkImage=null&blink=' + redirect;
      if (redirect === 'autopay'){
        this.azURL =  this.usUrl + '/home/manageYourProfile?openProfile=autopay';
      }
      else if (redirect === 'account'){
        this.azURL =  this.usUrl + '/home/accountdetails';
      }
      else if (redirect === 'pay'){
        this.azURL =  this.usUrl + '/home/pay';
      }
      else if (redirect === 'payoff'){
        this.azURL =  this.usUrl + '/home/payoff';
      }
      else if (redirect === 'insurance'){
        this.azURL =  this.usUrl + '/home/insurance';
      }
      else if (redirect ==='amortization'){
        this.azURL =  this.usUrl + '/home/amortization';
      }
      else if (redirect ==='documentcenter'){
        this.azURL =  this.usUrl + '/home/documentcenter';
      }

      else if (redirect ==='invoice'){
        this.azURL =  this.usUrl + '/home/invoice';
      }
      else if (redirect ==='manageYourProfile'){
        this.azURL =  this.usUrl + '/home/manageYourProfile';
      }
      else if (redirect ==='connected-insurance'){
        this.azURL =  this.usUrl + '/home/connected-insurance';
      }
    
      else if (redirect ==='ebill'){
        this.azURL =  this.usUrl + '/home/manageYourProfile?openProfile=ebill';
      }else if (redirect === 'title state transfer'){
        this.azURL =  this.usUrl + '/home/titletransfer';
      }
      if (redirect === 'autopay'){
        this.azURL =  this.usUrl + '/home/manageYourProfile?openProfile=autopay';
      }
    }
    setTimeout(() => {
      this._window.nativeWindow.location.href = this.azURL;
      if (sessionStorage.getItem('enableGA') === 'yes' && this.azURL) {
        this.enableGA('true',  redirect); 
      }
      if(redirect === 'account'){
        this.enableGA('true',  'accountdetails'); 
      }
      if(redirect ==='ebill'){
        this.enableGA('true',  'manageYourProfile?openProfile=ebill'); 
      }
      if(redirect ==='title state transfer'){
        this.enableGA('true',  'titletransfer'); 
      }
      if (redirect === 'autopay'){
        this.enableGA('true',  'manageYourProfile?openProfile=autopay');
      }
  }, 1000);  //1s
  }

  enableGA(toggle: string, page:string) {
    let redirect = '';
    this.translate.get('LoginModal.GARedirect').subscribe((data:any)=> {
      redirect= this.usUrl +  data + toggle +'&page='+ page;
     });
     this._window.nativeWindow.location.href = redirect;
  } 

 
  getDashBoardDetails(dashBoardRequest){
       this.auth.getDashBoardDetails(dashBoardRequest).subscribe(res => {
       this.newAccount = res.newAccount;
       this.recAccCount = res.recAccCount;
       this.liveAccFlag = res.liveAccFlag;
       sessionStorage.setItem('recAccCount', this.recAccCount);
       if(this.recAccCount && parseInt(this.recAccCount) > 450){
        this.lessAccounts = false;
       }
       if(!this.liveAccFlag){
        this.isTerminatedAccounts = true;
       }
       this.totalDue = res.totalDue;
       if (this.totalDue.includes("-")) {
         this.totalDue = "0.00";
       }
    });
  }

  getAccountSummary(){
     const thirdpartyRequest = {
      "thirdPartyNumber": this.thirdParty,
      "brandId":2,
      "ciamId":this.ciamId
    };
  
    this.auth.getODSThirdPartyAccountSummary(thirdpartyRequest).subscribe(res => {
      if(res){
        this.thirdPartyObject = res[0].thirdPartyObjectType;
        sessionStorage.setItem('thirdPartyObjectType', this.thirdPartyObject);
      }
    });
  }
}
